import BaseListagem from "components/BaseListagem";
import { Column } from "primereact/column";
import ContaService from "service/administracao/cadastro/ContaService";

const contaService = new ContaService();

export default function ContaListagem() {


    return (

        <BaseListagem ordenacao="nome,ASC" service={contaService} urlService="/conta" tituloPagina={'Contas'} >
            <Column field="nome" header="Nome"  />
        </BaseListagem>
    )
}
